import merge from 'lodash/merge.js';

import axios from '@/plugins/axios.js';
import Item from '@/store/quill/Item.js';
import { promiseError } from '@/store/utilities/Helpers.js';
import RecursiveSearch from '@/utilities/RecursiveSearch.js';

export default merge(Item(), {
    autoImport: false,

    state() {
        return {
            id: null,
            course_id: null,
            activity_id: null,
            user_id: null,
            title: null,
            body: null,
            user: null,
            all_replies: [],
            created_at: null,
            updated_at: null,
            reply_count: null,
            last_reply: null,
        };
    },

    getters: {},

    actions: {
        /**
         * @param context
         * @param data
         * @returns {Promise<any>}
         */
        async store(context, { course_id, activity_id, thread_id, data }) {
            try {
                const response = await axios.post(
                    `/api/courses/${course_id}/activities/${activity_id}/discussion-threads/${thread_id}/replies`,
                    data,
                    { errorHandle: false }
                );

                context.commit('ADD_REPLY', response.data.data);
            } catch (error) {
                promiseError({
                    key: 'discussion_thread_reply_error',
                    context,
                });

                throw error;
            }
        },
    },

    mutations: {
        ADD_REPLY(state, reply) {
            if (reply.reply_id) {
                const search = new RecursiveSearch();

                search.insert(state.all_replies, reply, {
                    subjectKey: 'reply_id',
                    container: 'all_replies',
                });
            } else {
                state.all_replies.push(reply);
            }
        },
    },
});
